import { render, staticRenderFns } from "./ChatwithTeacher.vue?vue&type=template&id=ea665514&scoped=true&"
import script from "./ChatwithTeacher.vue?vue&type=script&lang=js&"
export * from "./ChatwithTeacher.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea665514",
  null
  
)

export default component.exports